import { render } from "./multi-items.html?vue&type=template&id=2ad9ae3b"
import script from "./MultiItems.vue?vue&type=script&lang=ts"
export * from "./MultiItems.vue?vue&type=script&lang=ts"

import "./multi-items.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script